import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    actions: [],
    error: null,
    loading: false
};

const getFlowActionsStart = (state, action) => {
return updateObject( state, { error: null, loading: true } );
}

const getFlowActionsSuccess = (state, action) => {
return updateObject( state, { 
    actions: action.actions, loading: false      
 } );
}

const getFlowActionsFail = (state, action) => {
return updateObject( state, {
    error: action.error,
    loading: false
});
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_FLOWACTIONS_START: return getFlowActionsStart(state, action);
        case actionTypes.GET_FLOWACTIONS_SUCCESS: return getFlowActionsSuccess(state, action);
        case actionTypes.GET_FLOWACTIONS_FAIL: return getFlowActionsFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
